import { useStores } from "@stores";
import { observer } from "mobx-react-lite";

import { TOKEN_METADATA_BY_SYMBOL } from "@constants/metadata";

import { MarketRow } from "./MarketRow";

interface MarketListRowsProps {
  search: string;
  showFavorites: boolean;
  onSelect: (marketAddr: string) => void;
  onToggleFavorite: (address: string) => void;
}

export const MarketListRows = observer(({ search, showFavorites, onSelect, onToggleFavorite }: MarketListRowsProps) => {
  const { marketStore } = useStores();

  const availableMarkets = marketStore.allMarkets;
  const filteredMarkets = availableMarkets.filter((m) => m.base_symbol.toLowerCase().includes(search.toLowerCase()));

  const visibleMarkets = showFavorites
    ? filteredMarkets.filter((m) => marketStore.isFavorite(m.addr))
    : filteredMarkets;

  return (
    <>
      {visibleMarkets.map((market) => {
        const tokenMeta = TOKEN_METADATA_BY_SYMBOL[market.base_symbol];
        const instrumentInfo = marketStore.getInstrumentInfo(market.symbol);
        const maxLeverage = instrumentInfo?.leverage_filter?.max_leverage ?? market.max_leverage;

        return (
          <MarketRow
            key={market.addr}
            marketAddr={market.addr}
            baseSymbol={market.base_symbol}
            symbol={market.symbol}
            tokenIcon={tokenMeta?.icon}
            maxLeverage={maxLeverage}
            isFavorite={marketStore.isFavorite(market.addr)}
            onSelect={onSelect}
            onToggleFavorite={onToggleFavorite}
          />
        );
      })}
    </>
  );
});
